export const deselectOnBlur = () => {
  window.getSelection().removeAllRanges();
};

export const selectOnFocus = (ev) => {
  ev.target.select();
};
